import { Datas } from './datas';

export class Folha {
    Valor:number;
    DataFolha:Datas;
}